import {
  BooleanValue,
  DatetimeValue,
  DateValue,
  FieldDataType,
  NumericValue,
  ResourceValue,
  SaveFieldValue,
  SingleSelectValue,
  SpecificFieldValue,
  TextValue,
  TimeValue,
  UserValue,
} from 'mapistry-shared';

interface ConvertSpecificFieldValueToSaveValueParams {
  fieldType: FieldDataType;
  fieldValue: SpecificFieldValue;
}

export const convertSpecificFieldValueToSaveFieldValue = ({
  fieldType,
  fieldValue,
}: ConvertSpecificFieldValueToSaveValueParams): SaveFieldValue => {
  switch (fieldType) {
    case FieldDataType.BOOLEAN:
    case FieldDataType.DATE:
    case FieldDataType.DATETIME:
    case FieldDataType.NUMERIC:
    case FieldDataType.SINGLE_SELECT:
    case FieldDataType.TEXT:
    case FieldDataType.TIME:
      return fieldValue as
        | BooleanValue
        | DateValue
        | DatetimeValue
        | NumericValue
        | SingleSelectValue
        | TextValue
        | TimeValue;
    case FieldDataType.RESOURCE:
    case FieldDataType.USER:
      return {
        value: (fieldValue as ResourceValue | UserValue).value?.id || null,
      };
    case FieldDataType.FORMULA:
    default: {
      const exhaustiveCheck: never | FieldDataType.FORMULA = fieldType;
      throw new Error(`Unhandled field data type - ${exhaustiveCheck}`);
    }
  }
};
